navigator.serviceWorker.getRegistrations().then(function (registrations) {
	for (let registration of registrations) {
		registration.unregister();
	}
});

function domReady(fnc) {
	document.addEventListener("DOMContentLoaded", fnc);
}

function handleize(str) {
	str = str.toLowerCase();

	var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

	// For the old browsers
	for (var i = 0; i < toReplace.length; ++i) {
		str = str.replace(toReplace[i], "");
	}

	str = str.replace(/\W+/g, "-");

	if (str.charAt(str.length - 1) == "-") {
		str = str.replace(/-+\z/, "");
	}

	if (str.charAt(0) == "-") {
		str = str.replace(/\A-+/, "");
	}

	return str;
}

formatMoney = (cents, format) => {
	if (typeof cents === "string") {
		cents = cents.replace(".", "");
	}

	if (!format) {
		return cents;
	}

	let value = "";
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	const formatString = format;

	function formatWithDelimiters(
		number,
		precision = 2,
		thousands = ",",
		decimal = ".",
	) {
		if (isNaN(number) || number == null) {
			return 0;
		}

		number = (number / 100.0).toFixed(precision);

		const parts = number.split(".");
		const dollarsAmount = parts[0].replace(
			/(\d)(?=(\d\d\d)+(?!\d))/g,
			`$1${thousands}`,
		);
		const centsAmount = parts[1] ? decimal + parts[1] : "";

		return dollarsAmount + centsAmount;
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case "amount":
			value = formatWithDelimiters(cents, 2);
			break;
		case "amount_no_decimals":
			value = formatWithDelimiters(cents, 0);
			break;
		case "amount_with_comma_separator":
			value = formatWithDelimiters(cents, 2, ".", ",");
			break;
		case "amount_no_decimals_with_comma_separator":
			value = formatWithDelimiters(cents, 0, ".", ",");
			break;
	}

	return formatString.replace(placeholderRegex, value);
};

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute(
		"aria-expanded",
		summary.parentNode.hasAttribute("open"),
	);

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open"),
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(":focus-visible");
} catch (e) {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = [
		"ARROWUP",
		"ARROWDOWN",
		"ARROWLEFT",
		"ARROWRIGHT",
		"TAB",
		"ENTER",
		"SPACE",
		"ESCAPE",
		"HOME",
		"END",
		"PAGEUP",
		"PAGEDOWN",
	];
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener("keydown", (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener("mousedown", (event) => {
		mouseClick = true;
	});

	window.addEventListener(
		"focus",
		() => {
			if (currentFocusedElement)
				currentFocusedElement.classList.remove("focused");

			if (mouseClick) return;

			currentFocusedElement = document.activeElement;
			currentFocusedElement.classList.add("focused");
		},
		true,
	);
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*",
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });
		this.addEventListener("change", this.onQuantityChange);

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this)),
		);
	}

	onQuantityChange() {
		const quantityMax = parseInt(this.input.getAttribute("max"));
		const quantityStep = parseInt(this.input.dataset.moq);
		const inputQuantity = parseInt(this.input.value);
		const quantityMessageContainer = document.querySelector("#quantity-error");

		if (inputQuantity > quantityMax) {
			// this.input.value = quantityMax;
			document.querySelector(".product-form__submit").disabled = true;

			if (quantityMessageContainer) {
				quantityMessageContainer.innerHTML =
					"Quantity in cart cannot exceed available and incoming inventory.";
				quantityMessageContainer.classList.remove("hidden");
			}
		} else {
			document.querySelector(".product-form__submit").disabled = false;
			quantityMessageContainer.innerHTML = "";
			quantityMessageContainer.classList.add("hidden");
		}

		if (inputQuantity % quantityStep !== 0) {
			let newSelectedQuantity = inputQuantity;

			while (newSelectedQuantity % quantityStep !== 0) {
				newSelectedQuantity += 1;
			}

			this.input.value = newSelectedQuantity;
		}
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.defaultValue;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

		// determine if selected quantity matches the MOQ
		const minimumOrderQuantity = parseInt(this.input.dataset.moq);
		const inputQuantity = parseInt(this.input.value);

		if (inputQuantity % minimumOrderQuantity !== 0) {
			let newSelectedQuantity = inputQuantity;

			if (event.target.name === "plus") {
				while (newSelectedQuantity % minimumOrderQuantity !== 0) {
					newSelectedQuantity += 1;
				}
			} else {
				while (newSelectedQuantity % minimumOrderQuantity !== 0) {
					newSelectedQuantity -= 1;
				}
			}

			this.input.value = newSelectedQuantity;
		}

		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);

		// determine if pre-order variant should be added from product form
		if (
			event.target.classList.contains("quantity__button__main-product-form")
		) {
			const availableQuantity = parseInt(this.input.dataset.availableQty);
			const selectedQuantity = parseInt(this.input.value);

			if (selectedQuantity > availableQuantity) {
				this.toggleAddButton(false, `${window.variantStrings.preOrder}`, false);
			} else {
				this.toggleAddButton(
					false,
					`${window.variantStrings.addToCart}`,
					false,
				);
			}
		}
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", "disabled");
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute("disabled");

			if (text) {
				addButtonText.textContent = text;
			} else {
				addButtonText.textContent = window.variantStrings.addToCart;
			}
		}

		if (!modifyClass) return;
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

function slideUp(target, duration = 500) {
	if (!target) {
		return;
	}

	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + "ms";
	target.style.boxSizing = "border-box";
	target.style.height = target.offsetHeight + "px";
	target.style.overflow = "hidden";
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.style.display = "none";

	window.setTimeout(() => {
		// target.style.display = 'none'
		target.style.removeProperty("height");
		target.style.removeProperty("padding-top");
		target.style.removeProperty("padding-bottom");
		target.style.removeProperty("margin-top");
		target.style.removeProperty("margin-bottom");
		target.style.removeProperty("overflow");
		target.style.removeProperty("transition-duration");
		target.style.removeProperty("transition-property");
	}, duration);
}

function slideDown(target, duration = 500, display = "block") {
	if (!target) {
		return;
	}

	target.style.removeProperty("display");
	let elementDisplay = window.getComputedStyle(target).display;

	if (elementDisplay === "none") {
		elementDisplay = display;
	}

	target.style.display = elementDisplay;
	const height = target.offsetHeight;
	target.style.overflow = "hidden";
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.style.boxSizing = "border-box";
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + "ms";
	target.style.height = height + "px";
	target.style.removeProperty("padding-top");
	target.style.removeProperty("padding-bottom");
	target.style.removeProperty("margin-top");
	target.style.removeProperty("margin-bottom");

	window.setTimeout(() => {
		target.style.removeProperty("height");
		target.style.removeProperty("overflow");
		target.style.removeProperty("transition-duration");
		target.style.removeProperty("transition-property");
	}, duration);
}

function slideToggle(target, duration = 500, display = "block") {
	if (window.getComputedStyle(target).display === "none") {
		return slideDown(target, duration, display);
	} else {
		return slideUp(target, duration);
	}
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options,
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid,
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this),
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`,
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this)),
		);
		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onCloseButtonClick.bind(this)),
		);
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(
					event,
					this.mainDetailsToggle.querySelector("summary"),
				)
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const parentMenuElement = detailsElement.closest(".has-submenu");
		const isOpen = detailsElement.hasAttribute("open");
		const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

		function addTrapFocus() {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button"),
			);
			summaryElement.nextElementSibling.removeEventListener(
				"transitionend",
				addTrapFocus,
			);
		}

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(event, summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
				summaryElement.setAttribute("aria-expanded", true);
				parentMenuElement && parentMenuElement.classList.add("submenu-open");
				!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener(
							"transitionend",
							addTrapFocus,
						);
			}, 100);
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event === undefined) return;

		this.mainDetailsToggle.classList.remove("menu-opening");
		this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
			details.removeAttribute("open");
			details.classList.remove("menu-opening");
		});
		this.mainDetailsToggle
			.querySelectorAll(".submenu-open")
			.forEach((submenu) => {
				submenu.classList.remove("submenu-open");
			});
		document.body.classList.remove(
			`overflow-hidden-${this.dataset.breakpoint}`,
		);
		removeTrapFocus(elementToFocus);
		this.closeAnimation(this.mainDetailsToggle);
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		const parentMenuElement = detailsElement.closest(".submenu-open");
		parentMenuElement && parentMenuElement.classList.remove("submenu-open");
		detailsElement.classList.remove("menu-opening");
		detailsElement
			.querySelector("summary")
			.setAttribute("aria-expanded", false);
		removeTrapFocus(detailsElement.querySelector("summary"));
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary"),
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header =
			this.header || document.getElementById("shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains(
				"header-wrapper--border-bottom",
			)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
		);
		this.header.classList.add("menu-open");

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus) {
		super.closeMenuDrawer(event, elementToFocus);
		this.header.classList.remove("menu-open");
	}
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this, false),
		);
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		document.body.classList.remove("overflow-hidden");
		document.body.dispatchEvent(new CustomEvent("modalClosed"));
		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});
	}
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener("click", this.loadContent.bind(this));
	}

	loadContent(focus = true) {
		window.pauseAllMedia();
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(
					true,
				),
			);

			this.setAttribute("loaded", true);
			const deferredElement = this.appendChild(
				content.querySelector("video, model-viewer, iframe"),
			);
			if (focus) deferredElement.focus();
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector('[id^="Slider-"]');
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.enableSliderLooping = false;
		this.currentPageElement = this.querySelector(".slider-counter--current");
		this.pageTotalElement = this.querySelector(".slider-counter--total");
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		if (document.body.classList.contains("shop-the-room-products")) {
			setTimeout(() => {
				this.initPages();
			}, 1000);
		} else {
			this.initPages();
		}

		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener("scroll", this.update.bind(this));
		this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
		this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
	}

	initPages() {
		this.sliderItemsToShow = Array.from(this.sliderItems).filter(
			(element) => element.clientWidth > 0,
		);
		if (this.sliderItemsToShow.length < 2) return;
		this.sliderItemOffset =
			this.sliderItemsToShow[1].offsetLeft -
			this.sliderItemsToShow[0].offsetLeft;
		this.slidesPerPage = Math.floor(
			(this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
				this.sliderItemOffset,
		);
		this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
		this.update();
	}

	resetPages() {
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.initPages();
	}

	update() {
		const previousPage = this.currentPage;
		this.currentPage =
			Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

		if (this.currentPageElement && this.pageTotalElement) {
			this.currentPageElement.textContent = this.currentPage;
			this.pageTotalElement.textContent = this.totalPages;
		}

		if (this.currentPage != previousPage) {
			this.dispatchEvent(
				new CustomEvent("slideChanged", {
					detail: {
						currentPage: this.currentPage,
						currentElement: this.sliderItemsToShow[this.currentPage - 1],
					},
				}),
			);
		}

		if (this.enableSliderLooping) return;
		if (this.classList.contains("main-image-slider")) return;

		if (
			this.isSlideVisible(this.sliderItemsToShow[0]) &&
			this.slider.scrollLeft === 0
		) {
			this.prevButton.setAttribute("disabled", "disabled");
		} else {
			this.prevButton.removeAttribute("disabled");
		}

		if (
			this.isSlideVisible(
				this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
			)
		) {
			this.nextButton.setAttribute("disabled", "disabled");
		} else {
			this.nextButton.removeAttribute("disabled");
		}
	}

	isSlideVisible(element, offset = 0) {
		const lastVisibleSlide =
			this.slider.clientWidth + this.slider.scrollLeft - offset;
		return (
			element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
			element.offsetLeft >= this.slider.scrollLeft
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const step = event.currentTarget.dataset.step || 1;

		this.slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + step * this.sliderItemOffset
				: this.slider.scrollLeft - step * this.sliderItemOffset;
		this.slider.scrollTo({
			left: this.slideScrollPosition,
		});
	}
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
	constructor() {
		super();
		this.sliderControlWrapper = this.querySelector(".slider-buttons");
		this.enableSliderLooping = true;

		if (!this.sliderControlWrapper) return;

		this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
		if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

		this.sliderControlLinksArray = Array.from(
			this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
		);
		this.sliderControlLinksArray.forEach((link) =>
			link.addEventListener("click", this.linkToSlide.bind(this)),
		);
		this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
		this.setSlideVisibility();

		if (this.slider.getAttribute("data-autoplay") === "true")
			this.setAutoPlay();
	}

	setAutoPlay() {
		this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
		this.autoplaySpeed = this.slider.dataset.speed * 1000;

		this.sliderAutoplayButton.addEventListener(
			"click",
			this.autoPlayToggle.bind(this),
		);
		this.addEventListener("mouseover", this.focusInHandling.bind(this));
		this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
		this.addEventListener("focusin", this.focusInHandling.bind(this));
		this.addEventListener("focusout", this.focusOutHandling.bind(this));

		this.play();
		this.autoplayButtonIsSetToPlay = true;
	}

	onButtonClick(event) {
		super.onButtonClick(event);
		const isFirstSlide = this.currentPage === 1;
		const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

		if (!isFirstSlide && !isLastSlide) return;

		if (isFirstSlide && event.currentTarget.name === "previous") {
			this.slideScrollPosition =
				this.slider.scrollLeft +
				this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
		} else if (isLastSlide && event.currentTarget.name === "next") {
			this.slideScrollPosition = 0;
		}
		this.slider.scrollTo({
			left: this.slideScrollPosition,
		});
	}

	update() {
		super.update();
		this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
		this.prevButton.removeAttribute("disabled");

		if (!this.sliderControlButtons.length) return;

		this.sliderControlButtons.forEach((link) => {
			link.classList.remove("slider-counter__link--active");
			link.removeAttribute("aria-current");
		});
		this.sliderControlButtons[this.currentPage - 1].classList.add(
			"slider-counter__link--active",
		);
		this.sliderControlButtons[this.currentPage - 1].setAttribute(
			"aria-current",
			true,
		);
	}

	autoPlayToggle() {
		this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
		this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
		this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
	}

	focusOutHandling(event) {
		const focusedOnAutoplayButton =
			event.target === this.sliderAutoplayButton ||
			this.sliderAutoplayButton.contains(event.target);
		if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
		this.play();
	}

	focusInHandling(event) {
		const focusedOnAutoplayButton =
			event.target === this.sliderAutoplayButton ||
			this.sliderAutoplayButton.contains(event.target);
		if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
			this.play();
		} else if (this.autoplayButtonIsSetToPlay) {
			this.pause();
		}
	}

	play() {
		this.slider.setAttribute("aria-live", "off");
		clearInterval(this.autoplay);
		this.autoplay = setInterval(
			this.autoRotateSlides.bind(this),
			this.autoplaySpeed,
		);
	}

	pause() {
		this.slider.setAttribute("aria-live", "polite");
		clearInterval(this.autoplay);
	}

	togglePlayButtonState(pauseAutoplay) {
		if (pauseAutoplay) {
			this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
			this.sliderAutoplayButton.setAttribute(
				"aria-label",
				window.accessibilityStrings.playSlideshow,
			);
		} else {
			this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
			this.sliderAutoplayButton.setAttribute(
				"aria-label",
				window.accessibilityStrings.pauseSlideshow,
			);
		}
	}

	autoRotateSlides() {
		const slideScrollPosition =
			this.currentPage === this.sliderItems.length
				? 0
				: this.slider.scrollLeft +
					this.slider.querySelector(".slideshow__slide").clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}

	setSlideVisibility() {
		this.sliderItemsToShow.forEach((item, index) => {
			const button = item.querySelector("a");
			if (index === this.currentPage - 1) {
				if (button) button.removeAttribute("tabindex");
				item.setAttribute("aria-hidden", "false");
				item.removeAttribute("tabindex");
			} else {
				if (button) button.setAttribute("tabindex", "-1");
				item.setAttribute("aria-hidden", "true");
				item.setAttribute("tabindex", "-1");
			}
		});
	}

	linkToSlide(event) {
		event.preventDefault();
		const slideScrollPosition =
			this.slider.scrollLeft +
			this.sliderFirstItemNode.clientWidth *
				(this.sliderControlLinksArray.indexOf(event.currentTarget) +
					1 -
					this.currentPage);
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
	}

	async onVariantChange(ev) {
		this.updateOptions();
		this.currentVariant = await this.updateMasterId(ev);

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
			this.renderVariantAvailability();
		} else {
			this.toggleAddButton(true, "", false);
			// this.updatePickupAvailability();
			this.updateVariantSku();
			this.updateVariantOptionValues(ev);
			this.updateTearSheetPrice();
			this.removeErrorMessage();
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.updateShareUrl();
			this.updateTearSheetUrl();
			this.updateVariantOptionAvailability(ev);
			this.updateVariantQuantityFromCart();
			this.updateAll3DModel();
		}
	}

	updateOptions() {
		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value,
		);
	}

	updateMasterId(ev) {
		return new Promise((resolve) => {
			this.currentVariant = this.getVariantData().find((variant) => {
				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});

			// this means that the variant doesn't exist so we have to code around that
			if (!this.currentVariant) {
				// re-enable radios and labels first before disabling the one we need
				this.querySelectorAll('input[type="radio"]').forEach((radio) => {
					radio.disabled = false;
				});

				this.querySelectorAll("label").forEach((lbl) => {
					lbl.classList.remove("disabled");
				});

				// which of the options was clicked?
				let selectedOptionIndex = 1;
				let selectedOptionName = "";
				let selectedOptionValue = "";

				if (ev) {
					const siblingLegend = ev.target.parentNode.querySelector("legend");

					if (siblingLegend) {
						selectedOptionIndex = parseInt(
							siblingLegend.dataset.optionPosition,
						);
					}
				}

				// we don't know what order the options comes come in and can be different between products
				// we have to get the first option, get where it is then get the rest and determine
				// if they can be combined, whether that specific variant (combinatio of options) exists
				// this is because not all variants have all options
				this.productData =
					this.productData ||
					JSON.parse(this.querySelector("[data-product]").textContent);
				const productOptions = this.productData.options;
				const optionPositions = [];

				// loop over the options to get the one that was changed
				productOptions.forEach((opt, idx) => {
					const optionPosition = idx + 1; // options are 1-based
					optionPositions.push(optionPosition);

					// what option was changed
					if (optionPosition === selectedOptionIndex) {
						selectedOptionName = opt;
					}
				});

				const variantOptionKey = `option${selectedOptionIndex}`;
				selectedOptionValue = this.querySelector(
					`input[name="${selectedOptionName}"]:checked`,
				).value;

				const remainingOptionsIndices = optionPositions.filter((pos) => {
					return pos !== selectedOptionIndex;
				});

				this.options[selectedOptionIndex - 1] = selectedOptionValue;

				// this has to be done in order for this.currentVariantData to work below
				let foundMatch = false;

				this.productData.variants.forEach((variant) => {
				if (foundMatch) return;

				for (const otherOptionPosition of remainingOptionsIndices) {
					const variantOptionKey = `option${selectedOptionIndex}`;

					if (
						variant[variantOptionKey] == selectedOptionValue &&
						variant[variantOptionKey].indexOf("Preorder") === -1
					) {
					const otherOptionKey = `option${otherOptionPosition}`;
					const otherOptionName = productOptions[otherOptionPosition - 1];
					const otherOptionValue = variant[otherOptionKey];

					this.querySelectorAll(`input[name="${otherOptionName}"]`).forEach((ooi) => {
						if (ooi.value == otherOptionValue) {
							ooi.checked = true;
							ooi.click();
						} else {
							ooi.disabled = true;
							ooi.checked = false;
							this.querySelector(`[data-value="${ooi.value}"]`).classList.add("disabled");
						}
					});

						this.options[otherOptionPosition - 1] = otherOptionValue;

						foundMatch = true;
						break;
					}
				}
				});


				this.currentVariant = this.getVariantData().find((variant) => {
					return !variant.options
						.map((option, index) => {
							return this.options[index] === option;
						})
						.includes(false);
				});

				resolve(this.currentVariant);
			} else {
				resolve(this.currentVariant);
			}
		});
	}

	updateVariantOptionAvailability(ev) {
		// re-enable radios and labels first before disabling the one we need
		this.querySelectorAll('input[type="radio"]').forEach((radio) => {
			radio.disabled = false;
		});

		this.querySelectorAll("label").forEach((lbl) => {
			lbl.classList.remove("disabled");
		});

		let selectedOptionIndex = 1;
		let selectedOptionName = "";
		let selectedOptionValue = "";

		if (ev) {
			const siblingLegend = ev.target.parentNode.querySelector("legend");

			if (siblingLegend) {
				selectedOptionIndex = parseInt(siblingLegend.dataset.optionPosition);
			}
		}

		// we don't know what order the options comes come in and can be different between products
		// we have to get the first option, get where it is then get the rest and determine
		// if they can be combined, whether that specific variant (combinatio of options) exists
		// this is because not all variants have all options
		this.productData =
			this.productData ||
			JSON.parse(this.querySelector("[data-product]").textContent);
		const productOptions = this.productData.options;
		const optionPositions = [];

		// loop over the options to track them later
		productOptions.forEach((opt, idx) => {
			const optionPosition = idx + 1; // options are 1-based
			optionPositions.push(optionPosition);

			if (optionPosition === selectedOptionIndex) {
				selectedOptionName = opt;
			}
		});

		const variantOptionKey = `option${selectedOptionIndex}`;
		selectedOptionValue = this.querySelector(
			`input[name="${selectedOptionName}"]:checked`,
		).value;

		const remainingOptionsIndices = optionPositions.filter((pos) => {
			return pos !== selectedOptionIndex;
		});

    const otherOptionValues = [];

		this.productData.variants.forEach((variant) => {
			if (
				variant[variantOptionKey] == selectedOptionValue &&
				variant[variantOptionKey].indexOf("Preorder") === -1
      ) {
				for (const otherOptionPosition of remainingOptionsIndices) {
					const otherOptionKey = `option${otherOptionPosition}`;
					const otherOptionValue = variant[otherOptionKey];
          const preOrderSku = `PRE-${variant.sku}`;

          const variantMetadata = window.variantMetadata[variant.sku];
          const variantMetadataPreOrder = window.variantMetadata[preOrderSku];

          let inStockInventory = 0;
          let preOrderInventory = 0;

          if (variantMetadata && variantMetadata !== 0) {
            const variantMetadataArray = variantMetadata.split(',');
            for (const entry of variantMetadataArray) {
              const entryArray = entry.split('|');
              if (window.customer.currency === 'USD' || window.customer.currency === '') {
                inStockInventory = inStockInventory + Number(entryArray[0]);
              } else {
                const lowerCaseLocation = entryArray[2].toLowerCase();
                if (lowerCaseLocation === 'toronto') {
                  inStockInventory = inStockInventory + Number(entryArray[0]);
                }
              }
            }
          };

          if (variantMetadataPreOrder && variantMetadataPreOrder !== 0) {
            const variantMetadataPreOrderArray = variantMetadataPreOrder.split(',');
            for (const entry of variantMetadataPreOrderArray) {
              const entryArray = entry.split('|');
              if (window.customer.currency === 'USD' || window.customer.currency === '') {
                preOrderInventory = preOrderInventory + Number(entryArray[0]);
              } else {
                const lowerCaseLocation = entryArray[2].toLowerCase();
                if (lowerCaseLocation === 'toronto') {
                  preOrderInventory = preOrderInventory + Number(entryArray[0]);
                }
              }
            }
          };

					if (
						variant.available &&
						(inStockInventory > 0 || preOrderInventory > 0)
					) {
						otherOptionValues.push(otherOptionValue);
					}
				}
			}
		});

    const distinctOtherOptionValues = [...new Set(otherOptionValues)];

		for (const otherOptionPosition of remainingOptionsIndices) {
			const otherOptionName = productOptions[otherOptionPosition - 1];

			this.querySelectorAll(`input[name="${otherOptionName}"]`).forEach(
				(ooi) => {
          if (!distinctOtherOptionValues.includes(ooi.value)) {
						const optionInput = this.querySelector(
							`input[value="${ooi.value}"]`,
            );
						optionInput.disabled = true;
						this.querySelector(`[data-value="${ooi.value}"]`).classList.add(
							"disabled",
						);
					}
				},
			);
		}
	}

	updateVariantQuantityFromCart() {
		this.cartData =
			this.cartData ||
			JSON.parse(this.querySelector("[data-cart]").textContent);

		if (this.cartData) {
			const quantityInput = document.querySelector(".quantity__input");
			if (!quantityInput) return; // Marketing site does not have quantity input
			const availableQuantity = parseInt(quantityInput.dataset.availableQty);
			const availableMaxQuantity = parseInt(quantityInput.max);
			let variantSku = "";
			let totalVariantQuantityCart = 0;
			let inStockVariantQuantity = 0;
			let preOrderVariantQuantity = 0;

			// this gets the in-stock variant
			for (const cartItem of this.cartData.items) {
				if (cartItem.variant_id === this.currentVariant.id) {
					variantSku = cartItem.sku;
					const cartQuantity = cartItem.quantity;
					totalVariantQuantityCart += cartQuantity;
					inStockVariantQuantity += cartQuantity;
				}
			}

			// this gets the preorder variant, if it exists
			const preOrderVariantSku = `PRE-${variantSku}`;
			for (const cartItem of this.cartData.items) {
				if (cartItem.sku === preOrderVariantSku) {
					const cartQuantity = cartItem.quantity;
					totalVariantQuantityCart += cartQuantity;
					preOrderVariantQuantity += cartQuantity;
				}
			}

			const maxQuantityAfterCart =
				availableMaxQuantity - totalVariantQuantityCart;
			const availableQuantityAfterCart =
				availableQuantity - totalVariantQuantityCart;
			quantityInput.max = maxQuantityAfterCart;

			if (availableQuantityAfterCart < 0) {
				quantityInput.dataset.availableQty = 0;
			} else {
				quantityInput.dataset.availableQty = availableQuantityAfterCart;
			}
		}
	}

	updateVariantSku() {
		if (!this.currentVariant) return;
		const wrapper = this.closest('.product__info-wrapper');
		const allSkuContainers = wrapper.querySelectorAll('.product__sku');
		const skuContainers = Array.from(allSkuContainers).filter(el => {
		return !el.closest('.full-collection--grid');
		});

		const comCheckbox = this.querySelector('.js-com-material-checkbox');
		if (comCheckbox && comCheckbox.checked) {
			const updatedSku = this.currentVariant.sku.replace(/-[^-]+$/, "-CSWCOM");
			skuContainers.forEach((skuContainer ) => {
				skuContainer.innerHTML = `SKU: ${updatedSku}`;
			});
		} else {
			skuContainers.forEach((skuContainer) => {
				skuContainer.innerHTML = `SKU: ${this.currentVariant.sku}`;
			});
		}
	}

	updateVariantOptionValues(ev) {
		if (!this.currentVariant) return;

		const pos = parseInt(ev.target.dataset.optionPosition) - 1;
		const optionLabelContainer = this.querySelector(
			`.form__label[data-option-position="${ev.target.dataset.optionPosition}"] span`,
		);

		if (optionLabelContainer) {
			optionLabelContainer.innerHTML = this.options[pos];
		}

		const comOptionLabels = this.querySelectorAll(`.js-com-type-value-label[data-selection="${ev.target.dataset.selection}"]`);
		for (const comOptionLabel of comOptionLabels) {
			comOptionLabel.innerHTML = '';
		}

		const comOptionLabel = this.querySelector(
			`.js-com-type-value-label[data-type="${ev.target.dataset.type}"][data-selection="${ev.target.dataset.selection}"]`,
		);

		if (comOptionLabel) {
			comOptionLabel.innerHTML = ev.target.value;
		}
	}

	updateTearSheetPrice() {
		const tearSheetButton = document.getElementById("tear-sheet");

		if (tearSheetButton) {
			tearSheetButton.dataset.price = this.currentVariant.price;
		}
	}

	updateMedia() {
		if (!this.currentVariant) return;
		if (!this.currentVariant.featured_media) return;

		const mediaGalleries = document.querySelectorAll(
			`[id^="MediaGallery-${this.dataset.section}"]`,
		);
		const iframeModel = document.querySelector('.js-all3d');
		if (!iframeModel) mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));
	

		const modalContent = document.querySelector(
			`#ProductModal-${this.dataset.section} .product-media-modal__content`,
		);
		if (!modalContent) return;
		const newMediaModal = modalContent.querySelector(
			`[data-media-id="${this.currentVariant.featured_media.id}"]`,
		);
		modalContent.prepend(newMediaModal);

		// remove the existing variant classes and add them to the non-variant images
		if (window.hideVariants) {
			const productMediaItems = document.querySelectorAll(
				".product__media-item",
			);
			const productThumbnailMediaItems = document.querySelectorAll(
				".thumbnail-list__item",
			);
			const productDownloadMediaItems = document.querySelectorAll(
				".download-thumbnails-list__item",
			);

			// main images
			productMediaItems.forEach((media) => {
				if (!media.classList.contains("dimensions-image")) {
					const mediaSrc = media.dataset.mediaSrc;
					media.classList.remove("product__media-item--variant");

					if (mediaSrc && mediaSrc.indexOf(this.currentVariant.sku) === -1) {
						media.classList.add("product__media-item--variant");
					}
				}
			});

			// thumbnail images
			productThumbnailMediaItems.forEach((media) => {
				if (!media.classList.contains("dimensions-image")) {
					const mediaSrc = media.dataset.mediaSrc;
					media.classList.remove("thumbnail-list_item--variant");

					if (mediaSrc.indexOf(this.currentVariant.sku) === -1) {
						media.classList.add("thumbnail-list_item--variant");
					}
				}
			});

			// download section
			productDownloadMediaItems.forEach((media) => {
				const mediaLink = media.querySelector("a");
				const mediaFilename = mediaLink.dataset.filename;
				media.classList.remove("product__download-media-item--variant");

				if (
					mediaFilename &&
					mediaFilename.indexOf(this.currentVariant.sku) === -1
				) {
					media.classList.add("product__download-media-item--variant");
				}
			});
		}
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
		window.history.replaceState(
			{},
			"",
			`${this.dataset.url}?variant=${this.currentVariant.id}`,
		);
	}

	updateShareUrl() {
		const shareButton = document.getElementById(
			`Share-${this.dataset.section}`,
		);
		if (!shareButton || !shareButton.updateUrl) return;
		shareButton.updateUrl(
			`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
		);
	}

	updateTearSheetUrl() {
		const tearSheetButton = document.getElementById(`tear-sheet`);
		if (!tearSheetButton) return;
		const productHandle = tearSheetButton.dataset.handle;
		tearSheetButton.dataset.href = `/products/${productHandle}?variant=${this.currentVariant.id}&view=tear-sheet`;
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			const inputSku = document.querySelector('input[name="sku"]');

			if (inputSku) {
				inputSku.value = this.currentVariant.sku;
			}

			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	updateAll3DModel() {
		const iframe = document.querySelector('.js-all3d-iframe');
		if (!iframe || !this.currentVariant.sku) return;
		const skuSplit = this.currentVariant.sku.split('-');
		if (skuSplit.length < 4) return;
		const modelParameter = `${skuSplit[0]}-${skuSplit[1]}`;
		const finishParameter = skuSplit[2];
		const fabricParameter = skuSplit[3];

		const message = `loadVariation=model:${modelParameter};finish:${finishParameter};fabric:${fabricParameter};`;
		iframe.contentWindow.postMessage(message, '*');
	}

	removeErrorMessage() {
		const section = this.closest("section");
		if (!section) return;

		// const productForm = section.querySelector('product-form');
		// if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		let renderProductInfoDebounceTimer;
		if (renderProductInfoDebounceTimer) {
			clearTimeout(renderProductInfoDebounceTimer);
		}
		renderProductInfoDebounceTimer = setTimeout(() => {
			fetch(
				`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
			)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(
						responseText,
						"text/html",
					);
					const destination = document.getElementById(
						`price-${this.dataset.section}`,
					);
					const source = html.getElementById(
						`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
					);
					if (source && destination) destination.innerHTML = source.innerHTML;

					const price = document.getElementById(
						`price-${this.dataset.section}`,
					);

          if (price) price.classList.remove("visibility-hidden");

          const preOrderSku = `PRE-${this.currentVariant.sku}`;

          const variantMetadata = window.variantMetadata[this.currentVariant.sku];
          const variantMetadataPreOrder = window.variantMetadata[preOrderSku];

          let inStockInventory = 0;
          let preOrderInventory = 0;

          if (variantMetadata && variantMetadata !== 0) {
            const variantMetadataArray = variantMetadata.split(',');
            for (const entry of variantMetadataArray) {
              const entryArray = entry.split('|');
              const lowerCaseLocation = entryArray[2].toLowerCase();
              if (lowerCaseLocation === 'toronto') {
                inStockInventory = inStockInventory + Number(entryArray[0]);
              }
            }
          };

          if (variantMetadataPreOrder && variantMetadataPreOrder !== 0) {
            const variantMetadataPreOrderArray = variantMetadataPreOrder.split(',');
            for (const entry of variantMetadataPreOrderArray) {
              const entryArray = entry.split('|');
              const lowerCaseLocation = entryArray[2].toLowerCase();
              if (lowerCaseLocation === 'toronto') {
                preOrderInventory = preOrderInventory + Number(entryArray[0]);
              }
            }
          };

					if (
						this.currentVariant.available &&
            (inStockInventory > 0 || preOrderInventory > 0)
					) {
						this.toggleAddButton(false, window.variantStrings.addToCart);
					} else {
						this.toggleAddButton(true, window.variantStrings.soldOut);
					}
          this.renderAccordion(html);
					this.renderVariantAvailability();
					this.renderComWarranty(html);
				});
		}, 300);
  };

  renderComWarranty(newHtml) {
	const currentComWarranty = document.querySelector('.js-com-warranty');
	const newComWarranty = newHtml.querySelector('.js-com-warranty');
	if (currentComWarranty && newComWarranty) {
		currentComWarranty.innerHTML = newComWarranty.innerHTML;
	}
  }

  renderAccordion(newHtml) {
    // Construction
    const currentConstruction = document.querySelector('#product-detail__construction-container');
    const newConstruction = newHtml.querySelector('#product-detail__construction-container');
    if (currentConstruction && newConstruction) currentConstruction.innerHTML = newConstruction.innerHTML;
	}

	renderVariantAvailability() {
    const variantMetadataContainers = document.querySelectorAll('.product__availability');
    const variantMetadataLineItemProperty = document.querySelectorAll('.product__availability-property');

    let hasInStockInventory = false;
    let hasPreOrderInventory = false;
		let variantInventoryQuantity = 0;
		let totalAvailableQuantity = 0;

		if (window.variantMetafields) {
			const vMetafields =
				window.variantMetafields[`${this.currentVariant.sku}`];
			let detailsTemplate = "";

			// update product description tabs
			// details
			const detailsTab = document.querySelector(".tab-details__container");

			if (detailsTab) {
				detailsTab.innerHTML = "";
				detailsTemplate = "";

				// description
				if (vMetafields.product_details.description) {
					detailsTemplate = `<div class="rte">${vMetafields.product_details.description}</div>`;
					detailsTab.insertAdjacentHTML("beforeend", detailsTemplate);
				}

				// features & benefits
				if (vMetafields.product_details.features_benefits) {
					detailsTemplate = `<h3>Features & Benefits </h3>`;
					detailsTemplate += `<ul class="tab-details__container">`;
					for (const [key, value] of Object.entries(
						vMetafields.product_details.features_benefits,
					)) {
						detailsTemplate += `<li>${value}</li>`;
					}
					detailsTemplate += `</ul>`;
					detailsTab.insertAdjacentHTML("beforeend", detailsTemplate);
				}

				// details
				if (vMetafields.product_details.details) {
					detailsTemplate = `<h3>Details</h3>`;
					detailsTemplate += `<table class="product-details tab-details__table">`;
					detailsTemplate += `  <tbody>`;

					for (const [key, value] of Object.entries(
						vMetafields.product_details.details,
					)) {
						detailsTemplate += `<tr><td>${key}</td><td>${value}</td></tr>`;
					}

					detailsTemplate += `  </tbody>`;
					detailsTemplate += `</table>`;
					detailsTab.insertAdjacentHTML("beforeend", detailsTemplate);
				}
			}

			// dimensions
			const dimensionsTab = document.querySelector(
				".dimentions-table-container",
			);

			if (dimensionsTab) {
				dimensionsTab.innerHTML = "";
				detailsTemplate = "";

				// unit buttons
				const metricButton = document.querySelector("#dimensions-metric");
				const imperialButton = document.querySelector("#dimensions-imperial");
				const units = sessionStorage.getItem("sunpan__units");
				let unitClass = "is-imperial";

				if (units) {
					if (units === "metric") {
						metricButton.classList.add("dbutton--current");
						imperialButton.classList.remove("dbutton--current");
						unitClass = "is-metric";
					} else {
						metricButton.classList.remove("dbutton--current");
						imperialButton.classList.add("dbutton--current");
						unitClass = "is-imperial";
					}
				}

				if (vMetafields.product_details.dimensions) {
					const INCHES_TO_CM = 2.54;
					detailsTemplate = `<table class="product-details tab-dimensions__table ${unitClass}">`;
					detailsTemplate += `  <tbody>`;

					for (const [key, value] of Object.entries(
						vMetafields.product_details.dimensions,
					)) {
						let metric_value = value;
						const valueString = value.toString();

						if (valueString.search(" in") !== -1) {
              const measurement_raw = valueString.replace(' in', '');

              if (key.search('Overall Dimensions') !== -1) {
								// get the dimension metafields
								let overall_width;
								let overall_depth;
								let overall_height;
                let overall_string = '';

								if (vMetafields.product_details.overall_width) {
									overall_width = vMetafields.product_details.overall_width;
                  const overall_width_metric_value = overall_width * INCHES_TO_CM;
									overall_string += `${overall_width_metric_value}W x `;
								}

								if (vMetafields.product_details.overall_depth) {
									overall_depth = vMetafields.product_details.overall_depth;
                  const overall_depth_metric_value = overall_depth * INCHES_TO_CM;
									overall_string += `${overall_depth_metric_value}W x `;
								}

								if (vMetafields.product_details.overall_height) {
									overall_height = vMetafields.product_details.overall_height;
                  const overall_height_metric_value = overall_height * INCHES_TO_CM;
									overall_string += `${overall_height_metric_value}W x `;
								}

                metric_value = overall_string.replace(/( x $)/, '') + ' cm';
              } else if (key.search('Carton Size') !== -1 || key.includes('Dimension') || key.search(/Dimension\s+\d+/) !== -1) {
                // format: 95.00W x 40.00D x 27.00H in or possibly missing one or more parts
                let carton_size_width = '';
                let carton_size_depth = '';
                let carton_size_height = '';
                let carton_size_string = '';
                const carton_size_array = measurement_raw.split(' x ');

                carton_size_array.forEach((part) => {
                  const trimmed = part.trim().replace('in', '');
                  if (trimmed.includes('W')) {
                    carton_size_width = trimmed.replace('W', '').trim();
                  } else if (trimmed.includes('D')) {
                    carton_size_depth = trimmed.replace('D', '').trim();
                  } else if (trimmed.includes('H')) {
                    carton_size_height = trimmed.replace('H', '').trim();
                  }
                });

                const width = parseFloat(carton_size_width);
                if (!isNaN(width) && width > 0) {
                  const val = (width * INCHES_TO_CM).toFixed(2);
                  carton_size_string += `${val}W x `;
                }

                const depth = parseFloat(carton_size_depth);
                if (!isNaN(depth) && depth > 0) {
                  const val = (depth * INCHES_TO_CM).toFixed(2);
                  carton_size_string += `${val}D x `;
                }

                const height = parseFloat(carton_size_height);
                if (!isNaN(height) && height > 0) {
                  const val = (height * INCHES_TO_CM).toFixed(2);
                  carton_size_string += `${val}H x `;
                }

                metric_value = carton_size_string.replace(/ x $/, '') + ' cm';
							} else {
                metric_value = ((measurement_raw * INCHES_TO_CM).toFixed(2)) + ' cm';
							}
            } else if (valueString.search(' lb') !== -1) {
              const measurement_raw =valueString.replace(' lb', '');
              metric_value = ((measurement_raw * 0.45359237).toFixed(2)) + ' kg';
						}

            const valueTrimmed = valueString.replace('0000', '');

						detailsTemplate += `<tr>`;
						detailsTemplate += `  <td>${key}</td>`;
						detailsTemplate += `  <td>`;
						detailsTemplate += `    <span class="imperial">${valueTrimmed}</span>`;
						detailsTemplate += `    <span class="metric">${metric_value}</span>`;
						detailsTemplate += `  </td>`;
						detailsTemplate += `</tr>`;
					}

					detailsTemplate += `  </tbody>`;
					detailsTemplate += `</table>`;
          dimensionsTab.insertAdjacentHTML('beforeend', detailsTemplate);
				} else {
          dimensionsTab.insertAdjacentHTML('beforeend', `<p>Information not available.</p>`);
				}

				const dimensionsTable = document.querySelector(
					".tab-dimensions__table",
				);

				if (metricButton) {
					metricButton.addEventListener("click", (ev) => {
						ev.target.classList.add("dbutton--current");
						imperialButton.classList.remove("dbutton--current");
						dimensionsTable.classList.remove("is-imperial");
						dimensionsTable.classList.add("is-metric");
						sessionStorage.setItem("sunpan__units", "metric");
					});
				}

				if (imperialButton) {
					imperialButton.addEventListener("click", (ev) => {
						ev.target.classList.add("dbutton--current");
						metricButton.classList.remove("dbutton--current");
						dimensionsTable.classList.add("is-imperial");
						dimensionsTable.classList.remove("is-metric");
						sessionStorage.setItem("sunpan__units", "imperial");
					});
				}
			}

			// shipping
			const shippingTab = document.querySelector(".tab-shipping__container");

			if (shippingTab) {
				shippingTab.innerHTML = "";
				detailsTemplate = "";

				if (vMetafields.product_details.shipping) {
					detailsTemplate = `<table class="product-details tab-shipping__table">`;
					detailsTemplate += `  <tbody>`;

					for (const [key, value] of Object.entries(
						vMetafields.product_details.shipping,
					)) {
						detailsTemplate += `<tr><td>${key}</td><td>${value}</td></tr>`;
					}

					detailsTemplate += `  </tbody>`;
					detailsTemplate += `</table>`;
					shippingTab.insertAdjacentHTML("beforeend", detailsTemplate);
				} else {
					shippingTab.insertAdjacentHTML(
						"beforeend",
						`<p>Information not available.</p>`,
					);
				}
			}

			// features & benefits
			const featuresBenefitsTab = document.querySelector(
				".tab-features-benefits__container",
			);

			if (featuresBenefitsTab) {
				featuresBenefitsTab.innerHTML = "";

				if (vMetafields.product_details.features_benefits) {
					for (const [key, value] of Object.entries(
						vMetafields.product_details.features_benefits,
					)) {
						const featuresBenefitsTemplate = `<li>${value}</li>`;
						featuresBenefitsTab.insertAdjacentHTML(
							"beforeend",
							featuresBenefitsTemplate,
						);
					}
				} else {
					const featuresBenefitsTemplate = `<li>Information not available</li>`;
					featuresBenefitsTab.insertAdjacentHTML(
						"beforeend",
						featuresBenefitsTemplate,
					);
				}
			}
		}

    if (window.variantMetadata) {
      // In-stock inventory
      const variantInStockMetadata = window.variantMetadata[`${this.currentVariant.sku}`];
      if (variantInStockMetadata) {
        const variantInStockInventoryArray = variantInStockMetadata.split(",");
        let inStockCount = 0;
        for (const variantInStockInventory of variantInStockInventoryArray) {
          const inStockInventoryArray = variantInStockInventory.split('|')
          if (inStockInventoryArray[2] === 'Toronto' || inStockInventoryArray[2] === 'toronto') {
            inStockCount = Number.parseInt(inStockInventoryArray[0]);
          }
        }

        for (const container of variantMetadataContainers) {
          const availabilityContainer = container.querySelector('.product__availability-container');
          if (availabilityContainer) {
            // regular, not pre-order variant
            variantInventoryQuantity = inStockCount;
            if (variantInventoryQuantity > 0) {
              hasInStockInventory = true;
              totalAvailableQuantity = totalAvailableQuantity + Number.parseInt(variantInventoryQuantity);
              availabilityContainer.replaceChildren();
              const quantityTemplate = `<tr>
                  <td>${variantInventoryQuantity}</td>
                  <td>${window.variantStrings.inStock}</td>
                </tr>`;

              availabilityContainer.insertAdjacentHTML('beforeend', quantityTemplate);
            }
            if (hasInStockInventory) {
              container.classList.remove('hidden');
            }
          }
        }
      }

      // Pre-order inventory
      const variantMetadata = window.variantMetadata[`PRE-${this.currentVariant.sku}`];

      if (variantMetadata) {
        hasPreOrderInventory = true;
        const variantInventoryArray = variantMetadata.split(",");
				for (const container of variantMetadataContainers) {
					const availabilityContainer = container.querySelector('.product__availability-container');

					if (availabilityContainer) {
						if (!hasInStockInventory) {
							availabilityContainer.replaceChildren();
						}

						for (const element of variantInventoryArray) {
              const availabilityArray = element.split('|');
              if (availabilityArray[2] === 'Toronto' || availabilityArray[2] === 'toronto') {
                const quantity = availabilityArray[0];
                const date = availabilityArray[1];
                totalAvailableQuantity = totalAvailableQuantity + Number.parseInt(quantity);
                const markup = `<tr>
                  <td>${quantity}</td>
                  <td>${date}</td>
                </tr>`;
                availabilityContainer.insertAdjacentHTML('beforeend', markup);
              }
						}

						// add line item property
						// const productForm = document.querySelector('[data-type="add-to-cart-form"]');

						// if (productForm) {
						//   const propertyTemplate = `<input type="hidden" name="properties[Preorder]" value="preorder item" class="product__availability-property">`;
						//   productForm.insertAdjacentHTML('afterbegin', propertyTemplate);
						// }

						container.classList.remove('hidden');

						if (hasInStockInventory) {
							this.toggleAddButton(false, window.variantStrings.add_to_cart, false);
						} else if (hasPreOrderInventory) {
							this.toggleAddButton(false, window.variantStrings.preOrder, false);
						} else {
							this.toggleAddButton(true, window.variantStrings.soldOut);
						}
					}
				}
      } else {
        for (const lip of variantMetadataLineItemProperty) {
          lip.parentNode.removeChild(lip);
        }
      }
    }

    if (totalAvailableQuantity === 0) {
      for (const container of variantMetadataContainers) {
        container.classList.add('hidden');
      }

      for (const lip of variantMetadataLineItemProperty) {
        lip.parentNode.removeChild(lip);
      }
    }

		const quantityInput = this.closest('.product__info-wrapper').querySelector('.quantity__input');
		if (!quantityInput) return; // Marketing site does not have quantity input
		quantityInput.max = totalAvailableQuantity;
		quantityInput.dataset.availableQty = variantInventoryQuantity;
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", "disabled");
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute("disabled");

			if (text) {
				addButtonText.textContent = text;
			} else {
				addButtonText.textContent = window.variantStrings.addToCart;
			}
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector("[data-variant]").textContent);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
		this.updateOptions();
		this.updateMasterId();
		this.updateVariantOptionAvailability();
		this.updateVariantQuantityFromCart();
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked,
			).value;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

fullLinkProductCards = () => {
	const productCards = document.querySelectorAll(".product-card-wrapper");

	productCards.forEach((card) => {
		const mainLink = card.querySelector(".main-link");
		card.addEventListener("click", (ev) => {
			if (
				ev.target.classList.contains("color-swatch") ||
				ev.target.classList.contains("swatch-input")
			) {
				return;
			}

			const isTextSelected = window.getSelection().toString();

			if (!isTextSelected) {
				mainLink.click();
			}
		});
	});
};

domReady(fullLinkProductCards);

fullLinkCollectionCards = () => {
	const productCards = document.querySelectorAll(
		".section-collection-list .card-wrapper",
	);

	productCards.forEach((card) => {
		const mainLink = card.querySelector(".main-link");
		card.addEventListener("click", (ev) => {
			const isTextSelected = window.getSelection().toString();

			if (!isTextSelected) {
				mainLink.click();
			}
		});
	});
};

domReady(fullLinkCollectionCards);

showLargeScreenGuestMenu = (ev) => {
	const guestMenuContainer = document.querySelector("#nav--guest-menu");
	const headerContainer = document.querySelector(".header-header-container");

	if (guestMenuContainer) {
		slideToggle(guestMenuContainer, 500);

		if (headerContainer) {
			headerContainer.classList.add("is-open");
		}

		document.body.removeEventListener("click", hideLargeScreenGuestMenu);
		document.body.addEventListener("click", hideLargeScreenGuestMenu);
	}
};

hideLargeScreenGuestMenu = (ev) => {
	const tgt = ev.target;
	if (
		tgt.classList.contains("guest-menu-link") ||
		tgt.classList.contains("guest-megamenu-link") ||
		tgt.classList.contains("mega-menu-guest__link")
	)
		return;

	const guestMenuContainer = document.querySelector("#nav--guest-menu");

	if (guestMenuContainer) {
		slideUp(guestMenuContainer, 500);
		const headerContainer = document.querySelector(".header-header-container");

		if (headerContainer) {
			headerContainer.classList.remove("is-open");

			const guestDetailsContainer = document.querySelector(
				".header-item--guest",
			);

			if (guestDetailsContainer) {
				guestDetailsContainer.removeAttribute("open");
			}
		}
	}
};

setupLargeScreenGuestMenu = () => {
	const mainMenuItemGuest = document.querySelector(".header-item--guest");

	if (mainMenuItemGuest) {
		mainMenuItemGuest.addEventListener("click", showLargeScreenGuestMenu);
	}
};

// if (window.innerWidth >= 1150) {
//   domReady(setupLargeScreenGuestMenu);
// }

removeLargeScreenGuestMenu = () => {
	const mainMenuItemGuest = document.querySelector(".header-item--guest");

	if (mainMenuItemGuest) {
		mainMenuItemGuest.removeEventListener("click", showLargeScreenGuestMenu);
	}
};

function addMobileFooterMenuEvent(ev) {
	const dataMenu = ev.target.dataset.menu;
	const menu = document.getElementById(dataMenu);
	slideToggle(menu, 500);
	ev.target.classList.toggle("is-open");
	menu.classList.toggle("is-closed");

	if (menu.classList.contains("is-closed")) {
		menu.setAttribute("aria-expanded", false);
	} else {
		menu.setAttribute("aria-expanded", true);
	}
}

setupMobileFooterMenus = () => {
	const footerMenuHeadings = document.querySelectorAll(
		".js-footer__block-heading",
	);
	const footerMenuBlocks = document.querySelectorAll(".js-footer__nav-list");

	for (let i = 0; i < footerMenuBlocks.length; i++) {
		footerMenuBlocks[i].setAttribute("aria-expanded", false);
	}

	for (let i = 0; i < footerMenuHeadings.length; i++) {
		footerMenuHeadings[i].addEventListener("click", addMobileFooterMenuEvent);
	}
};

removeMobileFooterMenus = () => {
	const footerMenuHeadings = document.querySelectorAll(
		".js-footer__block-heading",
	);
	const footerMenuBlocks = document.querySelectorAll(".js-footer__nav-list");

	for (let i = 0; i < footerMenuBlocks.length; i++) {
		footerMenuBlocks[i].removeAttribute("aria-expanded");
	}

	for (let i = 0; i < footerMenuHeadings.length; i++) {
		footerMenuHeadings[i].removeEventListener(
			"click",
			addMobileFooterMenuEvent,
		);
	}
};

if (window.innerWidth < 1240) {
	domReady(setupMobileFooterMenus);
}

window.addEventListener(
	"resize",
	debounce((event) => {
		if (window.innerWidth < 1240) {
			setupMobileFooterMenus();
			const headerContainer = document.querySelector(
				".header-header-container",
			);

			if (headerContainer) {
				headerContainer.classList.remove("is-open");
			}

			document.querySelectorAll(".mega-menu").forEach((mm) => {
				mm.removeAttribute("open");
			});

			if (navigator.platform === "iPhone")
				document.documentElement.style.setProperty(
					"--viewport-height",
					`${window.innerHeight}px`,
				);

			removeLargeScreenGuestMenu();
		} else {
			removeMobileFooterMenus();
			// setupLargeScreenGuestMenu();
		}
	}, 300).bind(this),
);

function storeShopTheRoomCollection(strcln) {
	sessionStorage.setItem("sunpan__str-collection", strcln);
}

if (document.body.classList.contains("shop-the-room")) {
	const strContainer = document.querySelector("#shop-the-room");

	if (strContainer) {
		const selectedCollection = strContainer.dataset.collection;

		if (selectedCollection != "") {
			storeShopTheRoomCollection(selectedCollection);
		}
	}
}

function scrollFunction() {
	if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
		document.getElementById("scroll-top-button").style.opacity = "1";
	} else {
		document.getElementById("scroll-top-button").style.opacity = "0";
	}
}

function scrollToTop(ev) {
	window.scrollTo({ top: 0, behavior: "smooth" });
}

window.addEventListener("scroll", scrollFunction);

const scrollToTopBtn = document.querySelector(
	"#scroll-top-button .scroll-to-top",
);

if (scrollToTopBtn) {
	scrollToTopBtn.addEventListener("click", scrollToTop);
}

function removeCurrentNavigation(ev) {
	if (
		ev.target.classList.contains("mega-menu--label") ||
		ev.target.classList.contains("mega-menu__link")
	) {
		return;
	}

	sessionStorage.removeItem("sunpan__mega-menu");
}

function setupCurrentNavigation() {
	document.querySelectorAll(".mega-menu .mega-menu--label").forEach((mm) => {
		mm.addEventListener("click", (ev) => {
			const menuName = ev.target.dataset.menu;
			sessionStorage.setItem("sunpan__mega-menu", menuName);
			document.body.addEventListener("click", removeCurrentNavigation);
		});
	});

	const clickedLabel = sessionStorage.getItem("sunpan__mega-menu");

	if (clickedLabel) {
		document.querySelectorAll(".mega-menu .mega-menu--label").forEach((mm) => {
			const mmMenu = mm.dataset.menu;

			if (mmMenu !== clickedLabel) {
				mm.classList.remove("header__active-menu-item");
			}
		});

		const currentMegaMenu = document.querySelector(
			`.mega-menu .mega-menu--label[data-menu="${clickedLabel}"]`,
		);

		if (currentMegaMenu) {
			currentMegaMenu.classList.add("header__active-menu-item");
			sessionStorage.removeItem("sunpan__mega-menu");
			document.body.removeEventListener("click", removeCurrentNavigation);
		}
	}
}

domReady(setupCurrentNavigation);
